(function (root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};

    // see QueueConstants
    const AUTOREPLY_TYPE_INACTIVE = 0;
    const AUTOREPLY_TYPE_ALWAYS = 1;
    const AUTOREPLY_TYPE_OFFHOURS = 2;
    const AUTOREPLY_TYPE_SCHEDULED = 3;

    /**
     * Auto reply settings for deciding if captcha should be shown
     * @deprecated prefer usage in js/public/QuestionForm.js for import
     */
    class FormAutoReply {
        /**
         * @prop {Number} type Type of autoreply (see constants)
         * @prop {Number|null} start schedule start date in unix seconds
         * @prop {Number|null} end schedule end date in unix seconds
         * @prop {Boolean} libauth_enabled Is Libauth on for the form
         */
        constructor({
            type = 0,
            start = null,
            end = null,
            offhours = null,
            timezone = '',
            captchaAlwaysOn = false,
            libauth_enabled = false,
        }) {
            this.type = type;
            this.start = start;
            this.end = end;
            this.offhours = offhours;
            this.timezone = timezone;
            this.captchaAlwaysOn = captchaAlwaysOn;
            this.libauth_enabled = libauth_enabled;
        }

        /**
         * Should we enable the captcha because of the autoreply.
         * @returns {Boolean}
         */
        isCaptchaEnabled() {
            if (this.libauth_enabled) {
                return false;
            }
            if (this.captchaAlwaysOn) {
                return true;
            }
            return this.isAutoReplyEnabled();
        }

        /**
         * Is auto-reply enabled.
         * @returns {Boolean}
         */
        isAutoReplyEnabled() {
            if (this.type === AUTOREPLY_TYPE_INACTIVE) {
                return false;
            }
            if (this.type === AUTOREPLY_TYPE_ALWAYS) {
                return true;
            }
            if (this.type === AUTOREPLY_TYPE_SCHEDULED) {
                return this._isBetweenDates();
            }
            if (this.type === AUTOREPLY_TYPE_OFFHOURS) {
                return this._isNowOffHours();
            }
            return false;
        }

        /**
         * Get auto reply type
         * @returns {Number}
         */
        getAutoReplyType() {
            return this.type;
        }

        /**
         * Is now between the start/end timestamps.
         * @returns {Boolean}
         */
        _isBetweenDates() {
            if (!this.end || !this.start) {
                return false;
            }
            // calculate now compared to start/end.
            // milliseconds to unix seconds
            const unixTime = Math.floor(Date.now() / 1000);
            return (unixTime >= this.start
                && unixTime <= this.end);
        }

        _isNowOffHours() {
            if (!this.offhours || !this.timezone) {
                return false;
            }
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: this.timezone,
                weekday: 'short',
                hour: 'numeric',
                hour12: false,
            }).formatToParts(new Date());
            const weekdayMap = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
            const weekday = parts.find((p) => p.type === 'weekday')?.value;
            const hour = parseInt(parts.find((p) => p.type === 'hour')?.value ?? '0', 10);
            const day = weekdayMap[weekday] ?? -1;
            const range = Object.values(this.offhours).find((r) => r.day === day);
            if (!range) {
                return false;
            }
            return !this._isBetweenHours(range.start, range.end, hour);
        }

        _isBetweenHours(start, end, hour) {
            if (start === 24 && end === 24) return false;
            if (start === end) return true;
            if (hour === start) return true;
            if (start > end) return !(hour < start && hour > end);
            return hour > start && hour < end;
        }
    }

    root.springSpace.la.FormAutoReply = FormAutoReply;
})(window);
